import PNF from '../../assests/pageNotFound.gif';

export default function PageNotFound() {
    return (
        <div>
            <img src={PNF} className='img-fluid' style={{ display: "block", margin: "auto", marginTop: "10%" }} alt='pageNotFound' width={450} height={450} />
        </div>
    );
}
